import { ArrowLeftIcon } from 'lucide-react';
import { routes } from '../data/site';
import { SiteLink } from './SiteLink';
export function SpaCareReturn() {
  return <nav aria-label="Spa care guide" className="border-b border-ink/10 bg-white" data-id="element-473" data-mp="24obzznfcikan">
      <div className="mx-auto max-w-container px-5 py-1 sm:px-8" data-id="element-474" data-mp="28ovx4qzx5nws">
        <SiteLink to={routes.spaCare} className="inline-flex min-h-[44px] items-center gap-2 text-[15px] font-bold text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 hover:text-pegasus-magenta" data-id="element-475" data-mp="2dgxgsxzf2gwu">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-476" data-mp="2ndimllj9fw1q" />Back to Spa Care
        </SiteLink>
      </div>
    </nav>;
}